import { render, staticRenderFns } from "./addrecommend.vue?vue&type=template&id=c40e62b6&scoped=true"
import script from "./addrecommend.vue?vue&type=script&lang=js"
export * from "./addrecommend.vue?vue&type=script&lang=js"
import style0 from "./addrecommend.vue?vue&type=style&index=0&id=c40e62b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40e62b6",
  null
  
)

export default component.exports